import { FC, ReactNode } from 'react';
import styles from './SidebarMenu.module.css';
import { Backdrop } from '../Backdrop';
import CloseIcon from '../../assets/icons/close.svg?react';
import clsx from 'clsx';

export interface SidebarMenuProps {
  open?: boolean;
  onClose: () => void;
  children?: ReactNode;
  header?: ReactNode;
}

export const SidebarMenu: FC<SidebarMenuProps> = ({
  open,
  onClose,
  children,
  header,
}) => {
  return (
    <>
      <div className={clsx(styles.root, open && styles.open)}>
        <div className={styles.header}>
          <div className={styles.headerContent}>{header}</div>
          <CloseIcon className={styles.close} onClick={onClose} />
        </div>
        <div className={styles.content}>{children}</div>
      </div>
      {open && <Backdrop onClick={onClose} />}
    </>
  );
};
